import { TYPES } from "../../common/constants";
import { createReducer } from "@reduxjs/toolkit";

const fetchReportsDone = (_, { payload }) => {
  return [...payload];
};

const clearReportsDone = () => {
  return initialState;
};

const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_REPORTS_DONE]: fetchReportsDone,
  [TYPES.CLEAR_REPORTS_DONE]: clearReportsDone,
});
